/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import Spell from 'model/stats/Spell';
import AttributeValues from "model/stats/AttributeValues";

class NpcData {
    name:                                      string     = "";
    raceName:                                  string     = "";
    primaryClassName:                          string     = "";
    primaryArchetypeName:                      string     = "";
    secondaryClassName:                        string     = "";
    secondaryArchetypeName:                    string     = "";
    backgroundName:                            string     = "";
    primaryLevel:                              number     = 0;
    secondaryLevel:                            number     = 0;
    attributeBases:                            number[]   =[];
    diceArray:                                 string     = "";
    attributeValues:                           AttributeValues = new AttributeValues();
    asiRacialSelected:                         string[]   = [];
    asiClassSelected:                          string[]   = [];
    raceOptions:                               string     = "";
    primaryClassOptions:                       string     = "";
    secondaryClassOptions:                     string     = "";
    langsRaceSelected:                         string[]   = [];
    langsClassSelected:                        string[]   = [];
    langsBackgroundSelected:                   string[]   = [];
    skillsRaceSelected:                        string[]   = [];
    skillsClassSelected:                       string[]   = [];
    skillsBackgroundSelected:                  string[]   = [];
    spellbookSpellsArrayBySpellLevelPrimary:   Spell[][]  = [];
    spellbookSpellsArrayBySpellLevelSecondary: Spell[][]  = [];
    spellsPreparedArrayBySpellLevelPrimary:    Spell[][]  = [];
    spellsPreparedArrayBySpellLevelSecondary:  Spell[][]  = [];
    spellbookSpellKeysBySpellLevelPrimary:     string[]   = [];
    spellbookSpellKeysBySpellLevelSecondary:   string[]   = [];
    spellKeysPreparedBySpellLevelPrimary:      string[]   = [];
    spellKeysPreparedBySpellLevelSecondary:    string[]   = [];
    // Optional spellcasting attribute override. Empty means "use the class default".
    // e.g. a Wizard who casts using Charisma sets this to 'charisma'.
    primaryAttribute:                          string     = '';
    secondaryAttribute:                        string     = '';

    static getKeysFromSpells = (spellsBySpellLevel: Spell[][] | null): string[] => {
        const slugs: string[] = [];
        for (const level of spellsBySpellLevel?.keys() || []) {
            const levelSpells:Spell[] = spellsBySpellLevel?.[level] || [];
            slugs[level] = levelSpells.map(spell => spell.key).join(',');
        }
        return slugs;
    }
    static getSpellsFromKeys = (spellKeysBySpellLevel: string[] | null, keysToSpellMap: Map<string, Spell>): Spell[][] => {
        const spells: Spell[][] = [];
        for (const level of spellKeysBySpellLevel?.keys() || []) {
            spells[level] = [];
            const levelKeys:string = spellKeysBySpellLevel?.[level] || '';
            for (const key of levelKeys.split(',')) {
                const spell = keysToSpellMap.get(key);
                if (spell) {
                    spells[level].push(spell);
                }
            }
        }
        return spells;
    }
    static updateSpellsFromKeys = (npcData: NpcData, keysToSpellMap: Map<string, Spell>) => {
        npcData.spellbookSpellsArrayBySpellLevelPrimary   = NpcData.getSpellsFromKeys(npcData.spellbookSpellKeysBySpellLevelPrimary,   keysToSpellMap);
        npcData.spellbookSpellsArrayBySpellLevelSecondary = NpcData.getSpellsFromKeys(npcData.spellbookSpellKeysBySpellLevelSecondary, keysToSpellMap);
        npcData.spellsPreparedArrayBySpellLevelPrimary    = NpcData.getSpellsFromKeys(npcData.spellKeysPreparedBySpellLevelPrimary,    keysToSpellMap);
        npcData.spellsPreparedArrayBySpellLevelSecondary  = NpcData.getSpellsFromKeys(npcData.spellKeysPreparedBySpellLevelSecondary,  keysToSpellMap);    
    }
}
export default NpcData;